import { FC, useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import "./QuestionCard.css";

interface Props {
  questionNumber: number;
  totalQuestionsNumber: number;
  questionAnnouncement: string;
  isCorrection: boolean;
  correctAnswers: string[] | null;
  userAnswers: string[] | null;
  answers: {
    name: string;
    key: string;
  }[];
  getUserAnswers: ((userAnswers: string[]) => void) | null;
  showErrorMessage: boolean;
}

const QuestionCard: FC<Props> = ({
  isCorrection,
  questionNumber,
  totalQuestionsNumber,
  questionAnnouncement,
  correctAnswers,
  userAnswers,
  answers,
  getUserAnswers,
  showErrorMessage,
}) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>(
    userAnswers || []
  );

  useEffect(() => {
    console.log(isCorrection);
  }, [isCorrection]);

  useEffect(() => {
    setSelectedAnswers(userAnswers || []);
  }, [userAnswers]);

  const onCheckboxChange = (e: { checked: boolean; value: string }) => {
    let updatedAnswers: string[];
    if (e.checked) {
      updatedAnswers = [...selectedAnswers, e.value];
    } else {
      updatedAnswers = selectedAnswers.filter((item) => item !== e.value);
    }
    setSelectedAnswers(updatedAnswers);
    if (getUserAnswers) {
      getUserAnswers(updatedAnswers);
    }
  };

  const getLabelClass = (answerKey: string) => {
    if (isCorrection) {
      if (correctAnswers?.includes(answerKey)) {
        if (userAnswers?.includes(answerKey)) {
          return "right-answer-label";
        } else {
          return "missed-answer-label";
        }
      } else if (userAnswers?.includes(answerKey)) {
        return "false-answer-label";
      }
    }
    return "";
  };

  return (
    <>
      <h3 className="question__title">
        Question {questionNumber}/{totalQuestionsNumber}
      </h3>
      <br />
      <p className="question__announcement">{questionAnnouncement}</p>
      <br />
      <br />
      {answers.map((answer) => {
        return (
          <div key={answer.key} className="field-checkbox">
            <Checkbox
              inputId={answer.key}
              name="category"
              value={answer.key}
              onChange={onCheckboxChange}
              checked={selectedAnswers.includes(answer.key)}
              disabled={getUserAnswers === null}
            />
            <label
              htmlFor={answer.key}
              className={getLabelClass(answer.key)}
            >
              {answer.name}
            </label>
          </div>
        );
      })}
      {showErrorMessage && (
        <p className="error-message">
          Incorrect answer. Please try again.
        </p>
      )}
    </>
  );
};

export default QuestionCard;
